module.exports = __webpack_public_path__ + "static/media/pizza.3e8f75ba.jpg";